<div class="grey-background p-3 view-details-skeleton mi-view-details">
  <div class="col-12 p-0 flex gap-3 align-items-start view-details-skeleton__layout">
    <div class="view-details-skeleton__section view-details-skeleton__section--left">
      <div class="mi-section-title">
        <p-skeleton width="8rem" height="1.25rem"></p-skeleton>
      </div>
      <div class="grid m-0">
        <div class="mi-field-row" *ngFor="let _ of leftFieldRows">
          <div class="mi-field-label">
            <p-skeleton width="60%" height="1rem"></p-skeleton>
          </div>
          <div class="mi-field-value">
            <p-skeleton width="80%" height="1rem"></p-skeleton>
          </div>
        </div>
      </div>
    </div>

    <div class="view-details-skeleton__right flex flex-column gap-3" *ngIf="rightSectionModels.length">
      <div class="view-details-skeleton__section" *ngFor="let section of rightSectionModels">
        <div class="mi-section-title">
          <p-skeleton width="10rem" height="1.25rem"></p-skeleton>
        </div>
        <div class="grid m-0">
          <div class="mi-field-row" *ngFor="let __ of section.fields">
            <div class="mi-field-label">
              <p-skeleton width="60%" height="1rem"></p-skeleton>
            </div>
            <div class="mi-field-value">
              <p-skeleton width="80%" height="1rem"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="view-details-skeleton__map mt-3" *ngIf="section.showMap">
          <p-skeleton width="100%" height="100%"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>
